
import { Link } from "react-router-dom";
import Picon from "../../images/project/icon-arrow.svg"
import Picon1 from "../../images/project/icon-bg.svg"
const ProjectCard = ({ Pimg, Psubtitle, Ptitle, Pslug }) => {
    const ClickHandlar = () => {
        window.scrollTo(10, 0);
    }
    return(
      <>
      <div className="container">
        <div className="project-card" style={{maxWidth:"250px",padding:"0 0 40px",margin:"auto"}}>
            <div className="image">
                <img src={Pimg} alt="" style={{maxWidth:"100px"}} />
            </div>
            {/* <div className="content">
                <span>{Psubtitle}</span>
                <h2>{Ptitle}</h2>
                <Link onClick={ClickHandlar} to={`/project-single/${Pslug}`} className="project-link">
                    <div className="icon">
                        <img src={Picon} alt="" />
                    </div>
                    <div className="shape">
                        <img src={Picon1} alt="" />
                    </div>
                </Link>
            </div> */}
        </div>
        </div>
        </>
    )
}

export default ProjectCard;